const setting = {
  passwordTitle: "पासवर्ड",
  changePasswordBtn: "पासवर्ड बदलें",
  changePasswordTips:
    "अगर आप अपना पासवर्ड भूल जाते हैं या इसे बदलना चाहते हैं, तो आप यहाँ ऐसा कर सकते हैं; हम आपके पंजीकृत ईमेल पते पर एक सत्यापन कोड भेजेंगे, जिसे आपकी पहचान की पुष्टि करने के लिए सत्यापित करना होगा, और फिर आप अपने खाते का पासवर्ड बदल सकते हैं।",
  feedbackTitle: "फीडबैक",
  feedbackBtn: "फीडबैक दें",
  feedbackTips:
    "हमें आपकी बेहतर सेवा करने का मौका देने के लिए, आप यहाँ अपनी समस्या बता सकते हैं और फीडबैक के लिए इसे हमारे पास जमा कर सकते हैं, और हमारी ग्राहक सेवा टीम आपसे जल्द से जल्द संपर्क करेगी।",
  appearanceTitle: "अपीयरेंस डिस्प्ले",
  appearanceBtn: "डिस्प्ले बदलें",
  appearanceTips: "हम आपके लिए दो अपीयरेंस मोड चुनते हैं, ताकि आप अपनी पसंद के अनुसार डार्क और लाइट मोड के बीच स्विच कर सकें।",
  changePassWordModalTitle: "पासवर्ड बदलें",
  changePassWordSameErrorTips: "आपके द्वारा डाला गया नया पासवर्ड आपके पुराने पासवर्ड के समान है। अलग पासवर्ड डालें",
  changePasswordCurrentErrorTips: "आपका पासवर्ड गलत है। कृपया दोबारा कोशिश करें।",
  currentPasswordLabel: "वर्तमान पासवर्ड",
  newPasswordLabel: "नया पासवर्ड",
  retypePasswordLabel: "नया पासवर्ड दोबारा टाइप करें",
  changePasswordSuccessTips: "आपका पासवर्ड सफलतापूर्वक बदल दिया गया है।",
  changePasswordComfirmDiffErrorTips: "कृपया दोनों क्षेत्रों में एक ही पासवर्ड डालें।",
  forgotPassword: "पासवर्ड भूल गए?",
  feedbackModalSubtitle: "हमें संपर्क करने और उत्पाद पर अपनी राय बताने के लिए धन्यवाद!",
  feedBackModalProductQuestion: "आप हमारे उत्पाद के साथ किस तरह की समस्याओं का समाधान करना चाहते हैं?",
  feedBackModalProductTypeSug: "सुझाव",
  feedBackModalProductTypeMem: "सदस्य सेवा से संबंधित सवाल",
  feedBackModalProductTypeFun: "कार्यक्षमता पूछताछ",
  feedBackModalProductTypeReq: "उत्पाद आवश्यकताएँ",
  feedBackModalProductTypeBug: "उत्पाद त्रुटियों पर फीडबैक",
  feedBackModalProductTypeIss: "प्रदर्शन समस्याएं",
  feedBackModalProductTypeRL: "पंजीकरण और लॉग इन संबंधी सवाल",
  feedBackModalProductTypeRef: "धनवापसी सेवा",
  feedBackModalProductTypeOth: "अन्य",
  feedBackModalProductSelectQuestion: "आप हमारे उत्पाद के साथ किस तरह की समस्याओं का समाधान करना चाहते हैं?",
  feedBackModalProductContQuestion: "उत्पाद का प्रयोग करते समय आपको किस समस्या का सामना करना पड़ा?",
  feedBackModalAddImageBtn: "छवियां जोड़ें",
  feedBackModalTips: "उपाय:",
  feedBackModalTipsCont: "वैश्विक ग्राहक सेवा के समय के अंतर के कारण, हम आपको कार्य दिवस के 48 घंटों के अंदर जवाब देंगे;",
  feedBackSuccessTips: "सफलतापूर्वक भेजें",
  feedBackSuccessSubTips: "हम आपकी समस्या का जल्द से जल्द समाधान करेंगे",
  feedBackFailedTips: "भेजने में विफल",
  feedBackFailedSubTips: "कृपया इस बात का ध्यान रखें कि आपका नेटवर्क कनेक्शन काम कर रहा हो और उसके बाद जमा करें",
  appearanceLightMode: "लाइट मोड",
  appearanceDarkMode: "डार्क मोड",
  promotionModalTitle: "प्रमोशन",
  promoItem: "प्रोमो आइटम",
  promoCode: "प्रोमो कोड",
  discount: "छूट",
  applyBtn: "लागू करें",
  applyPromotionErrorTips: "आपका प्रोमो कोड अमान्य है",
};

export default setting;
